import React from 'react'
import { css } from '@emotion/core'
import { TableHeader, TableBody, TableRow, TableDisabledOverlay } from '@/components/atoms/settings/table'
import { useTranslation } from 'react-i18next'
import { Select } from '@/components/atoms/select'
import { Select as AntSelect } from 'antd'
import { Control, Controller, useFieldArray } from 'react-hook-form'
import { ListType } from '@/components/pages/setting/smart-key/space'
import { useSmartLockDevices } from '@/hooks/use-smart-lock-devices'
import { AccountInfo, SmartLockDeviceType } from '@/models/lock-setting'

type Props = {
  lockType: SmartLockDeviceType
  accountInfo: AccountInfo | undefined
  control: Control<{ assign: ListType[] }, any>
  onChange: () => void
}

export const LinkSpaceToSmartLock: React.FC<Props> = ({ lockType, accountInfo, control, onChange: parentOnChange }) => {
  const { t } = useTranslation()
  const { deviceList } = useSmartLockDevices(lockType, accountInfo)

  const assignForm = useFieldArray({
    control,
    name: 'assign',
  })

  return (
    <>
      <TableHeader>
        <div css={assetNameColStyle}>{t('Asset')}</div>
        <div css={spaceNameColStyle}>{t('Space name')}</div>
        <div css={keyNumberColStyle}>{t('Device name')}</div>
      </TableHeader>
      <TableBody>
        {!accountInfo?.isConnected && <TableDisabledOverlay />}
        {assignForm.fields.map((space, i) => (
          <Controller
            key={`${space.spaceId}-${space.spaceIndex}`}
            name={`assign.${i}.remoteDeviceId`}
            control={control}
            render={({ field: { onChange, value } }) => (
              <TableRow css={css({ '> div': { fontWeight: 500 } })}>
                <div css={assetNameColStyle}>
                  {assignForm.fields[i].assetName === assignForm.fields[i - 1]?.assetName ? '' : assignForm.fields[i].assetName}
                </div>
                <div css={spaceNameColStyle}>{`${space.spaceName} - ${space.spaceIndex}`}</div>
                <div css={keyNumberColStyle}>
                  <Select
                    value={deviceList?.length ? value : ''}
                    onChange={selectVal => {
                      onChange(selectVal)
                      parentOnChange()
                    }}
                    customStyle={css({ paddingBottom: 0 })}
                  >
                    <AntSelect.Option value="">-</AntSelect.Option>
                    {deviceList?.map(device => (
                      <AntSelect.Option key={device.id} value={device.id}>
                        {device.name}
                      </AntSelect.Option>
                    ))}
                  </Select>
                </div>
              </TableRow>
            )}
          />
        ))}
      </TableBody>
    </>
  )
}

const assetNameColStyle = css({
  padding: '0 32px',
  width: 200,
  overflowWrap: 'anywhere',
})
const spaceNameColStyle = css({
  flexGrow: 1,
  overflowWrap: 'anywhere',
  width: 'min-content',
  paddingRight: 32,
})
const keyNumberColStyle = css({
  width: 300,
  paddingRight: 32,
})
